<template>
  <v-dialog style="z-index: 99998" v-model="value" max-width="290">
    <v-card>
      <v-card-title class="headline">Удаление</v-card-title>

      <v-card-text>{{ text }}</v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="closeHandler">Отмена</v-btn>

        <v-btn color="green darken-1" text @click="deleteHandler()">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "wapi-delete-dialog",
  props: {
    value: Boolean,
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    deleteHandler() {
      this.$emit("delete");
    },
    closeHandler() {
      this.$emit("input", false);
    }
  }
};
</script>